import React, { useState } from "react";
import "./CodeBlock.css";

// scroll: cap the height and scroll inside the block (use for long files)
const CodeBlock = ({ title, code, scroll = false }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={`docs-code${scroll ? " docs-code-scroll" : ""}`}>
      <div className="docs-code-header">
        <span>{title}</span>
        <button className="docs-code-copy" onClick={handleCopy}>
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
      <pre>{code}</pre>
    </div>
  );
};

export default CodeBlock;
